import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "@/lib/api";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { Reveal } from "@/components/Motion";
import policies from "@/data/policies.json";

const POLICY_LINKS = [
  ["Shipping", "/shipping"],
  ["Returns", "/returns"],
  ["Size Guide", "/size-guide"],
  ["Order Lookup", "/order-lookup"],
  ["Contact", "/contact"],
  ["Privacy", "/privacy"],
  ["Terms", "/terms"],
];

export default function PolicyPage({ slug }) {
  const page = policies[slug];

  useEffect(() => {
    setPageMeta(page.title, page.description, { canonicalPath: page.path });
  }, [page]);

  return (
    <div className="bg-night min-h-screen" data-testid={`policy-page-${slug}`}>
      <div className="px-5 lg:px-10 pt-10">
        <Breadcrumbs light items={[["Home", "/"], ["Shop", "/shop"], [page.h1, page.path]]} />
      </div>
      <header className="px-5 lg:px-10 pt-8 pb-10 border-b border-white/10">
        <Reveal>
          <p className="font-mono-label text-white/40">NINJA RUN CLUB</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-none uppercase">{page.h1}</h1>
          <p className="text-white/60 text-sm max-w-2xl mt-5 leading-relaxed" data-testid="policy-direct-answer">{page.answer}</p>
        </Reveal>
      </header>
      <div className="px-5 lg:px-10 py-12 max-w-3xl">
        {page.sections.map((s) => (
          <section key={s.h2} className="mb-10">
            <h2 className="font-display text-2xl text-white uppercase">{s.h2}</h2>
            {s.body.map((para, i) => (
              <p key={`${i}-${para.slice(0, 30)}`} className="text-white/60 text-sm mt-3 leading-relaxed">{para}</p>
            ))}
          </section>
        ))}
        <div className="border border-white/15 p-6 mt-4" data-testid="policy-links">
          <p className="font-mono-label text-white/40 mb-4">STORE POLICIES</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {POLICY_LINKS.filter(([, p]) => p !== page.path).map(([label, p]) => (
              <Link key={p} to={p} className="font-mono-label text-white/70 hover:text-white link-underline">{label.toUpperCase()}</Link>
            ))}
            <Link to="/shop" className="font-mono-label text-white/70 hover:text-white link-underline">BACK TO SHOP</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
